const ShowPassword = () => {
  const showPasswordButtons = [...document.querySelectorAll(".form__show-password")];

  showPasswordButtons.forEach(showPasswordButton => {
    showPasswordButton.addEventListener("click", () => {
      const passwordInput = showPasswordButton.parentElement.querySelector("input");
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
        showPasswordButton.classList.add("active");
      } else {
        passwordInput.type = "password";
        showPasswordButton.classList.remove("active");
      }
    });
  });
}

export default ShowPassword;
